const ITEMS_PER_PAGE = 10

export default ITEMS_PER_PAGE
